import React from 'react'
import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'
import { encryption } from '../../utilities/encryption'

export type FormProps = {
    password: string
    newPassword: string
    confirmNewPassword: string
}

export type ChangePasswordProps = {
    userId: number
    password: string
    newPassword: string
}

const usePreferenceChangePassword = () => {
    const callApi = useCallApi()

    const putPreferencesChangePassword = async (param: ChangePasswordProps) => {
        if (param.userId) {
            try {
                const { data } = await callApi.axiosPut<any>({
                    url: `${umServinceURL.putPreferencesChangePassword}/${param.userId}`,
                    authorizationType: 'authorization',
                    params: {
                        password: encryption(param.password),
                        newPassword: encryption(param.newPassword)
                    }
                })
                return data
            } catch (error) {
                console.log('error', error)
            }
        }
    }

    return {
        putPreferencesChangePassword
    }
}

export default usePreferenceChangePassword
